(function () {
  // Kör först när sidan är redo
  document.addEventListener('DOMContentLoaded', function () {

    // Lyssna när en variant byts
    document.addEventListener('afterVariantChanged', function (event) {
      try {
        const { variant, sectionId } = event.detail || {};
        if (!variant || !sectionId) return;

        const addButton = document.querySelector(`#product-form-${sectionId} [name="add"]`);
        const addButtonText = addButton?.querySelector('span');
        if (!addButton || !addButtonText) return;

        // Återställ knappens standardläge
        addButton.removeAttribute('disabled');
        addButton.removeAttribute('data-pre-order');

        if (!variant.available) {
          // Om slutsåld
          addButton.setAttribute('disabled', 'disabled');
          addButtonText.textContent = window.variantStrings?.soldOut || 'Slutsåld';
          return;
        }

        // Pre-order villkor
        const isPreOrder =
          variant.inventory_management === 'shopify' &&
          variant.inventory_quantity < (variant.quantity_rule?.min || 1) &&
          variant.inventory_policy === 'continue' &&
          window.theme?.settings?.enable_pre_order_text;

        if (isPreOrder) {
          addButton.dataset.preOrder = 'true';
          addButtonText.textContent = window.variantStrings?.preOrder || 'Pre-order';
        } else {
          addButtonText.textContent = window.variantStrings?.addToCart || 'Lägg i varukorgen';
        }
      } catch (error) {
        console.error('Preorder-fix error:', error);
      }
    });

  });
})();
